export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7551.214e9b14.jpg";